interface Tile {
  name: string;
  meta: string;
  starred?: boolean;
}

const tiles: Tile[] = [
  { name: 'Patel Textiles', meta: '★ HOT · MOQ 500', starred: true },
  { name: 'Krishna Engineering', meta: 'AUTO COMPONENTS' },
  { name: 'Surya Pharma', meta: 'BULK APIs' },
  { name: '+20 more', meta: 'VIEW ALL →' },
];

export function RecallMock() {
  return (
    <div className="w-full max-w-[320px] bg-white rounded-lg overflow-hidden shadow-elevated border border-ink-200">
      <div className="px-4 py-3.5 bg-gradient-to-br from-ink-900 to-violet-900 text-white">
        <div className="text-[11px] text-saffron-400 font-mono tracking-wide mb-1">
          VIBRANT GUJARAT · SURAT
        </div>
        <div className="text-[15px] font-bold -tracking-[0.01em]">
          Your Mela Recall · 23 stalls
        </div>
      </div>

      <div className="p-3 grid grid-cols-2 gap-2">
        {tiles.map((tile, i) => (
          <div
            key={i}
            className={`rounded-sm p-2.5 text-[11px] leading-snug ${
              tile.starred ? 'bg-saffron-50 border-l-2 border-saffron-500' : 'bg-bg-soft'
            }`}
          >
            <div className="font-semibold text-ink-900 mb-0.5">{tile.name}</div>
            <div className="text-ink-500 font-mono text-[10px]">{tile.meta}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
